const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/5521992215234?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20da%20JR%20Gráfica%20e%20Sublimação."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-10 right-10 z-[9999] w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-[#25D366] to-[#128C7E] shadow-2xl hover:scale-110 transition-transform duration-300 cursor-pointer animate-pulse"
      aria-label="Falar no WhatsApp"
    >
      <i className="ri-whatsapp-line text-white text-3xl"></i>
    </a>
  );
};

export default WhatsAppButton;